/**
 * LoadingSpinner component module.
 * @module shared/components/LoadingSpinner
 *
 */
import React from 'react';
import {withTheme} from 'styled-components/macro';
import {Row} from '../../shared';
import {Ring} from 'react-spinners-css';
import PropTypes from 'prop-types';

// const getColor = (props) => {
//   if (props.theme.dark) {
//     return '#FFFFFF';
//   }
//   return '#000000';
// };

// const _LoadingSpinner = styled.div`
//   content: " ";
//   display: block;
//   width: 26px;
//   height: 26px;
//   border-radius: 50%;
//   border: 2px solid;
//   border-color: ${props => getColor(props)} ${props => getColor(props)} transparent transparent;
//   animation: ring 1.2s linear infinite;
//
//   @keyframes ring {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `;

function LoadingSpinner(props) {
  const {
    theme,
    show,
  } = props;

  return show === undefined || show === true ? (
    <Row>
      <Ring
        color={theme.primaryColor || '#00D0BE'}
        size={30}
      />
    </Row>
  ) : null;
}

export default withTheme(LoadingSpinner);

LoadingSpinner.propTypes = {
  theme: PropTypes.object,
  show: PropTypes.bool,
};

LoadingSpinner.defaultProps = {
  show: undefined,
};
